<template>
  <a-layout-content id="main_content" class="all-c-main main-content">
    <div class="overlay en" v-show="isEnglish">
      <h6>
        <span class="pink">{{ $t('helpingYourChild') }}</span>
        {{ $t('playLearnGrowThrive1') }} <br />
        {{ $t('playLearnGrowThrive2') }} <br />
        {{ $t('playLearnGrowThrive3') }}
      </h6>
    </div>
    <div class="overlay cn" v-show="!isEnglish">
      <h6><span class="pink">{{ $t('helpingYourChildCn') }}</span>
        <span>{{ $t('playLearnGrowThriveCn1') }}</span><br />
        <span>{{ $t('playLearnGrowThriveCn2') }}</span>
        <span class="pink">{{ $t('playLearnGrowThriveCn3') }}</span>
        <span>{{ $t('playLearnGrowThriveCn4') }}</span><br />
        <span>{{ $t('playLearnGrowThriveCn2') }}</span>
        <span class="pink">{{ $t('playLearnGrowThriveCn6') }}</span>
        <span>{{ $t('playLearnGrowThriveCn7') }}</span><br />
        <span>{{ $t('playLearnGrowThriveCn8') }}</span>
        <span class="pink">{{ $t('playLearnGrowThriveCn9') }}</span>
      </h6>
    </div>
  </a-layout-content>
</template>

<script>
export default {
  data() {
    return {
      isEnglish: true
    };
  },
  computed: {
    currentLang() {
      console.log(this.$i18n.locale);
      return this.$i18n.locale;
    }
  },
  watch: {
    currentLang(newLang) {
      this.isEnglish = newLang === 'en';
      console.log(this.isEnglish);
    }
  }
};
</script>

<style scoped lang="less">
@mainBg: #f8f5f0;
@mainBg2: #f8f5f1;
@mainColor1: #de94a4;
@mainColor2: #eebac0;
@mainColor3: #A98578;
@mainFontColor: #3d3d3d;
@mainFont: "MontserratMedium", sans-serif;
@mainFontSub: "MontserratLight", sans-serif;
@mainFontCn: 'Huangchan', sans-serif;

.main-content {
  position: relative;
  height: calc(100vh - 110px);
  box-sizing: border-box;
  background-color: #f8f5f0;
  background-image: url('../../public/1.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: right bottom;
  color: white;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  padding: 6vw;
  overflow: hidden;
  margin-top: 110px;
  font-size: 1vw;
}


.overlay {
  padding: 2em;
  color: #333;

  h6 {
    font-size: 4em;
    font-weight: 600;
    margin: 0;
    color: #A98578;
    text-shadow: 0.2vw 0.2vw 0 #fff;
    font-family: @mainFont;

    .pink {
      color: pink;
      text-shadow: 0.2vw 0.2vw 0 #fff;
    }
  }

  .cn {
    h6 {
      font-size: 4.5em;
    }
  }

  @media screen and (min-width: 768px) and (max-width: 1500px) {
    h6 {
      font-size: 5em;
    }

    .cn {
      h6 {
        font-size: 2em;
      }
    }
  }

  @media screen and (min-width: 1501px) {
    h6 {
      font-size: 4.5em;
    }

    .cn {
      h6 {
        font-size: 3em;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  h6 {
    font-size: 6em !important;
  }

  .main-content {
    height: 90vw !important;
  }
}

@media screen and (max-width: 1300px) {
  h6 {
    
  }
}
</style>
